module.exports = __webpack_public_path__ + "media/images/global/contact/icon-contact-44a525b8e762ba1b774a819db287292c.svg";